import { useUser } from "../../utils/Contexts/Context";
import IndividualDashboard from "./Individual/IndividualDashboard";
import CompanyDashboard from "./Company/CompanyDashboard";
import { Redirect } from "react-router";
function Dashboard() {
    const {
        user: { mode },
    } = useUser();
    return mode === "individual" ? (
        <IndividualDashboard />
    ) : mode === "company" ? (
        <CompanyDashboard />
    ) : (
        <Redirect to="/" />
    );
}

export default Dashboard;
